<template>
  <div>
    <Desktop v-if="!mobile" :menu="menu" :categories="categories" />
    <Mobile v-else :menu="menu" :categories="categories" />
  </div>
</template>

<script>
import Desktop from "./Desktop";
import Mobile from "./Mobile";
import { formatToURL } from "@/components/utils.js";
import { menu } from "@/config.js";

const _config = {
  path: "/noticias",
};

export default {
  data: () => ({
    menu,
  }),
  computed: {
    categories() {
      return this.$rest("articles-categories")
        .list.filter(({ show_in_menu }) => show_in_menu == 1)
        .map(({ title }) => ({
          text: title,
          to: `${_config.path}/${formatToURL(title)}`,
        }));
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>
